module.exports = __webpack_public_path__ + "static/fonts/Montserrat-ExtraBold.2fa6a24.woff2";